import { DateTime } from 'luxon';

import aguid from 'lib/aguid';

const bonusPeriodClosed = ({
  link,
  bonusPeriod,
}: {
  link: string;
  bonusPeriod: BonusPeriod | BonusTypes.BonusPeriod;
}): Notifications.BasicNotification => ({
  id: aguid(),
  isBasic: true,
  type: 'BONUS_PERIOD_CLOSED',
  seen: false,
  read: false,
  deleted: false,
  createdOn: DateTime.utc().toISO(),
  emailSent: false,
  link,
  inAppSubject: `${bonusPeriod.label} has been closed`,
  inAppBody: `The bonus period (${bonusPeriod.label}) has been closed`,
  inAppLinkText: 'Open campaign',
  emailSubject: `${bonusPeriod.label} has been closed`,
  emailBodyLn1: `The bonus period (${bonusPeriod.label}) has been closed`,
  emailBodyLn2: '',
  emailLinkText: 'Log in to review',
});

export default bonusPeriodClosed;
